import {
  ERROR_TECNICO,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_OTROS,
  ERROR_NOSIS,
  RECHAZADO,
  GRACIAS
} from "./step-constants";

export const step1 = {
  APROBADO: "paso2",
  RECHAZADO_OTROS,
  INDIVIDUO_NEGATIVO,
  RECHAZADO_NOSIS_CALIFICACION_ACTIVA: RECHAZADO_OTROS,
  RECHAZADO: RECHAZADO_OTROS,
  ERROR_TECNICO
};

export const step2 = {
  APROBADO: "paso3",
  EXCEDIDO: "paso4",
  ERROR_NOSIS,
  RECHAZADO,
  ERROR_TECNICO,
  ERROR: ERROR_TECNICO
};

export const step4 = {
  GRACIAS,
  ERROR_TECNICO,
  ERROR: ERROR_TECNICO
};
